import React from "react";
import { FinancialAccount } from "@common/types/financialAccount";
import { getLeadingAccountConnection } from "@common/helpers/financialAccount";
import { isIntegrationConnection } from "@common/helpers/integrationConnection";
import { AccountDetailsField } from "./AccountDetailsField";

interface Props {
    account: FinancialAccount;
}
export const FinancialAccountInfo: React.FC<Props> = ({ account }) => {
    const connection = getLeadingAccountConnection(account);
    const provider =
        connection &&
        (isIntegrationConnection(connection)
            ? connection.provider
            : connection.connectionProvider);
    const providerId =
        connection &&
        (isIntegrationConnection(connection)
            ? connection.providerId
            : connection.connectionExternalId);

    return (
        <AccountDetailsField title={provider ? `${provider} ID` : "ID"}>
            {providerId}
        </AccountDetailsField>
    );
};
